// src/components/ScrollToTopButton.js
import React, { useState, useEffect } from "react";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(window.pageYOffset > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const buttonStyle = {
    position: "fixed",
    bottom: "40px",
    right: "30px",
    backgroundColor: "#5A7D9A",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: "12px 16px",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: 1000,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    display: isVisible ? "block" : "none",
    transition: "opacity 0.3s ease-in-out",
  };

  return (
    <button onClick={scrollToTop} style={buttonStyle} title="Go to top">
      ↑
    </button>
  );
}
